var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSperm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8774 3.0767C15.8988 1.22079 12.6338 1.88361 10.3458 4.14704C8.29348 6.2779 7.60611 8.95375 8.61753 10.7802C8.16092 11.0453 7.53737 11.4087 7.39499 11.4774C6.32465 12.0862 5.19539 13.0682 5.51453 15.091C5.19539 15.6802 4.36072 17.0697 3.12345 16.7702C2.56373 16.7211 2.05311 17.1286 2.00401 17.6883C1.95491 18.248 2.36242 18.7586 2.92214 18.8077C4.12014 18.9845 5.21012 18.6015 6.17735 17.5852C6.63396 17.1286 7.86633 16.1614 7.5521 14.0747C7.6012 13.8194 7.91052 13.515 8.41623 13.2106C8.54388 13.1271 9.53075 12.6999 10.1494 12.2482C12.0495 13.2547 14.5584 12.6165 16.812 10.5642C19.0803 8.1289 19.8315 5.28611 17.8774 3.0767ZM15.3833 9.13541C13.5077 10.7949 11.9415 11.0993 10.6502 10.2058C9.69278 8.9292 10.2132 7.37279 11.7205 5.62489C13.3064 4.20596 15.344 3.48421 16.4536 4.55455C17.4945 5.97349 16.7433 7.5299 15.3833 9.13541Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSperm);
export default __webpack_public_path__ + "static/media/sperm.bf3ac368dafb68ea58d662edb128a022.svg";
export { ForwardRef as ReactComponent };